import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "button-style-number-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.04 7.06c.28.11.46.39.46.69V15h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H11V9.56l-.72.72a.75.75 0 1 1-1.06-1.06l2-2a.75.75 0 0 1 .82-.16Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 11.75a9.75 9.75 0 1 1 19.5 0 9.75 9.75 0 0 1-19.5 0Zm9.75-8.25a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Z"
    }, null, -1)
  ])))
}
export default { render: render }